<template lang="">
    <div>
      <LaudoRetorno></LaudoRetorno>
    </div>
  </template>
  <script>
  import LaudoRetorno from '../components/laudos/formularios/exames/retorno/LaudoRetorno.vue';
  export default {
    components: {
      LaudoRetorno,
    },
  };
  </script>
  <style lang=""></style>
  